import { locationsApi } from '../../settings/locations/api/locationsApi';
import { Location } from '../../settings/locations/types/location.types';

export const inventoryLocationsApi = {
  /**
   * Get all active locations for inventory transactions
   */
  getAllActiveLocations: async (): Promise<Location[]> => {
    try {
      const response = await locationsApi.getAll({ 
        page: 1, 
        limit: 1000, // Get all locations
        isActive: true 
      });
      return response.data;
    } catch (error) {
      console.error('Error loading locations:', error);
      throw error;
    }
  },
};
